const expertGROUP = "/expert";
const expertCaseGROUP = (case_id) => `${expertGROUP}/case/${case_id}`;
const expertCaseSponsorshipGROUP = (case_id) =>
  `${expertCaseGROUP(case_id)}/sponsorship`;
const expertCaseSponsorshipDecisionGROUP = (case_id) =>
  `${expertCaseSponsorshipGROUP(case_id)}/decision`;
const expertCaseSponsorshipDocumentGROUP = (case_id, document_id) =>
  `${expertCaseSponsorshipGROUP(case_id)}/documents/${document_id}`;
export default {
  GetCasesURL: expertGROUP + "/cases",
  GetCompaniesURL: expertGROUP + "/companies",
  usercase: {
    GetCaseURL: (case_id) => `${expertCaseGROUP(case_id)}`,
    sponsorship: {
      GetCaseUserflowsURL: (case_id) =>
        `${expertCaseSponsorshipGROUP(case_id)}/userflows`,
      GetCaseOverviewURL: (case_id) =>
        `${expertCaseSponsorshipGROUP(case_id)}/overview`,
      GetCaseDocumentsURL: (case_id) =>
        `${expertCaseSponsorshipGROUP(case_id)}/documents`,
      GetCaseOnlineApplicationURL: (case_id) =>
        `${expertCaseSponsorshipGROUP(case_id)}/online_application`,
      GetCaseCandidateURL: (case_id) =>
        `${expertCaseSponsorshipGROUP(case_id)}/candidate`,
      GetCaseCoverLetterURL: (case_id) =>
        `${expertCaseSponsorshipGROUP(case_id)}/cover_letter`,
      UpdateCaseCoverLetterURL: (case_id) =>
        `${expertCaseSponsorshipGROUP(case_id)}/cover_letter`,
      NotyfyOAURL: (case_id) => `${expertCaseSponsorshipGROUP(case_id)}/notify`,
      UpdateCaseCreditsURL: (case_id) =>
        `${expertCaseSponsorshipGROUP(case_id)}/credits`,
      AddExpertNoteURL: (case_id) =>
        `${expertCaseSponsorshipGROUP(case_id)}/note`,
      decision: {
        ApproveCaseURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/approve_case`,
        RejectCaseURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/reject_case`,
        ApproveCandidateURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/approve_candidate`,
        RejectCandidateURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/reject_candidate`,
        ApproveCompanyProfileURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(
            case_id
          )}/approve_company_profile`,
        RejectCompanyProfileURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(
            case_id
          )}/reject_company_profile`,
        ApproveCaseProfileURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/approve_case_profile`,
        RejectCaseProfileURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/reject_case_profile`,
        ApproveCoverLetterURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/approve_cover_letter`,
        RejectCoverLetterURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/reject_cover_letter`,
        ApproveOnlineAppURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/approve_oa`,
        ConfirmDocumentsURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/confirm_docs`,
        ApproveAllDocsURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(
            case_id
          )}/documents/approve_all`,
        RejectAllDocsURL: (case_id) =>
          `${expertCaseSponsorshipDecisionGROUP(case_id)}/documents/reject_all`,
      },
      review: {
        ResumeCaseReviewURL: (case_id) =>
          `${expertCaseSponsorshipGROUP(case_id)}/review/resume`,
      },
      documents: {
        ApproveDocumentURL: (case_id, document_id) =>
          `${expertCaseSponsorshipDocumentGROUP(case_id, document_id)}/approve`,
        UnapproveDocumentURL: (case_id, document_id) =>
          `${expertCaseSponsorshipDocumentGROUP(
            case_id,
            document_id
          )}/unapprove`,
        DownloadFileURL: (case_id, document_id, file_id) =>
          `${expertCaseSponsorshipDocumentGROUP(
            case_id,
            document_id
          )}/file/${file_id}`,
        RequestDocumentURL: (case_id, document_id) =>
          `${expertCaseSponsorshipDocumentGROUP(case_id, document_id)}/request`,
        RequestChangeURL: (case_id, document_id) =>
          `${expertCaseSponsorshipDocumentGROUP(
            case_id,
            document_id
          )}/request_change`,
      },
    },
  },
};
